import { useEffect } from 'react';
import './typography.css';

export const SectionTypography=()=>{
  useEffect(()=>{
    const id='allrounder-section-fonts';
    if(document.getElementById(id))return;
    const link=document.createElement('link');link.id=id;link.rel='stylesheet';
    link.href='https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,500;0,600;1,500&family=Noto+Serif+KR:wght@400;500;600&family=Manrope:wght@400;500;600&display=swap';
    document.head.appendChild(link);
  },[]);
  return null;
};